import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.config";
import useAuth from "../hooks/useAuth";

// Custom protected route specifically for the plans page
// This prevents users with active subscriptions from accessing the plans page
export default function PlansProtectedRoute({ children }) {
  const { token, loading, user } = useAuth();
  const navigate = useNavigate();
  const [checkingSubscription, setCheckingSubscription] = useState(true);

  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (!loading && token && user?.uid) {
        try {
          const userRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(userRef);

          const userData = docSnap.exists() ? docSnap.data() : "";
          console.log("our plan", userData.subscription_status);

          // If user has an active subscription, redirect to login page
          if (userData.subscription_status) {
            console.log("User already has an active subscription");
            navigate("/login", {
              state: {
                message: "You already have an active subscription. Please log in to access your dashboard."
              }
            });
          }
        } catch (error) {
          console.error("Error checking subscription status:", error);
        } finally {
          setCheckingSubscription(false);
        }
      } else if (!loading && !token) {
        // If user is not logged in, allow them to see the plans
        setCheckingSubscription(false);
      } else if (!loading) {
        setCheckingSubscription(false);
      }
    };

    checkSubscriptionStatus();
  }, [token, loading, navigate, user]);

  if (loading || checkingSubscription) {
    return <div className="text-center mt-10">Loading...</div>;
  }

  return children;
}